<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search by name or email"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No users found..."/>

      <b-table
        v-if="data.length"
        ref="table"
        :responsive="true"
        :busy="fetching"
        :items="data"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged">

        <template slot="info" slot-scope="data">
          <span class="name">{{ data.value.name }}</span>
          <span>{{ data.value.email }}</span>
          <div class="no-wrap">
            <b-badge v-if="data.value.is_owner" variant="secondary">Owner</b-badge>
            <b-badge v-if="data.value.email === client.email" variant="secondary">Me</b-badge>
          </div>
        </template>

        <template slot="status" slot-scope="data">
          <div class="no-wrap">
            <span :class="{'bad-value': data.value ==='pending'}">
              {{ data.value }}
            </span>
          </div>
        </template>

        <template slot="joined" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div v-if="view === 'active'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="suspend">
              <b-button
                :disabled="data.item.info.email === client.email || fetching"
                title="suspend"
                variant="outline-secondary"
                @click.stop="suspend(data.item.info.id)">
                <i class="fas fa-lock"></i>
              </b-button>
            </span>
          </div>
          <div v-if="view === 'suspended'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="reactivate">
              <b-button
                :disabled="fetching"
                title="reactivate"
                variant="outline-secondary"
                @click.stop="reactivate(data.item.info.id)">
                <i class="fas fa-unlock"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="ban">
              <b-button
                :disabled="fetching"
                title="ban"
                variant="outline-secondary"
                @click.stop="archive(data.item.info.id)">
                <i class="fas fa-ban"></i>
              </b-button>
            </span>
          </div>
          <div v-if="view === 'banned'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="restore">
              <b-button
                :disabled="fetching"
                title="restore"
                variant="outline-secondary"
                @click.stop="restore(data.item.info.id)">
                <i class="fas fa-check"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12" class="my-1">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'

export default {
  mixins: [tableMixin],
  data () {
    return {
      formFields: [
        { key: 'info', label: 'Name', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'memberships', label: 'Memberships', sortable: false },
        { key: 'joined', label: 'Joined', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      namespace: 'users'
    }
  },
  methods: {
    suspend (id) {
      this.$store.dispatch(`${this.namespace}/update`, {
        id,
        data: { 'is_active': false }
      })
    },
    reactivate (id) {
      this.$store.dispatch(`${this.namespace}/update`, {
        id,
        data: { 'is_active': true }
      })
    },
    restore (id) {
      this.$store.dispatch(`${this.namespace}/update`, {
        id,
        data: { 'is_deleted': false }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/users/table.vue